import { useCallback } from 'react';
import CommonTableRow from './commonTableRow';
import CustomTable from './customTable';
import { MEMBERS_REDUCER_KEYS } from '../../../containers/browsingHistory/browsingHistoryReducer';

const headCells = [
  { id: 'accessedAt', label: '日時', sortable: true },
  { id: 'margeText', label: 'ページタイトル' },
];

export default function ContentsTable(props) {
  const {
    data,
    getApiDataFromListApi,
    isSP,
    handleOpenModal = null,
  } = props;
  const contentsTablelimit = localStorage.getItem('contentsTablelimit') ? localStorage.getItem('contentsTablelimit') : 20;
  const setContentsTablelimit = useCallback((current) => {
    localStorage.setItem('contentsTablelimit', current);
  }, []);
  return (
    <CustomTable
      hideHeader={isSP}
      title="コンテンツ閲覧履歴"
      headCells={headCells}
      total={data.total}
      list={data.histories}
      rowRender={(list) => list.map((row, i) => (<CommonTableRow
        key={String(i)}
        date={row.accessedAt}
        title={row.title}
        url={row.url}
      />))}
      onPageChange={(pageInfo) => {
        getApiDataFromListApi(MEMBERS_REDUCER_KEYS.contentsHistories, pageInfo);
      }}
      divider
      contentHeight={(isSP || handleOpenModal === null) ? null : 130}
      propLimit={contentsTablelimit}
      setPropLimit={setContentsTablelimit}
      isNoSlice
      handleOpenModal={handleOpenModal}
    />
  );
}
